import Vue from 'vue'
import Vuex from 'vuex'
import userinfo from './modules/userinfo'
import repoList from './modules/repoList'
import editor from './modules/editor'
import getters from './getters'
import logs from './modules/logs'
import tags from './modules/tags'
import search from './modules/search'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    repoList,
    userinfo,
    editor,
    logs,
    tags,
    search
  },
  getters
})

export default store
